module.exports = __webpack_public_path__ + "static/media/Logo.32044410.svg";